import { FormProvider } from 'react-hook-form';
import Form from './form';
import FormItem from './form-item';
import FormItemController from './form-item-controller';
import FormList from './form-list';
import type { FieldArrayActions, FormItemProps, FormProps } from './form-types';

/**
 * Luôn luôn bộc Provider các component còn lại.
 *
 * Để các mọi nơi trong component đều có thể access vào FormContext của RHF
 */
const CustomForm = {
    FormProvider: FormProvider,
    /**Chỉ sử dụng được trong FormProvider */
    Form: Form,
    /**Chỉ sử dụng được trong FormProvider */
    Item: FormItem,
    /**
     * Component hỗ trợ render cho FormItem.
     * Bao gồm render label, description, error,...
     */
    Control: FormItemController,
    /**Chỉ sử dụng được trong FormProvider */
    List: FormList,
    name: 'Form Custom with react-hook-form and zod',
};

export type { FieldArrayActions, FormItemProps, FormProps };
export default CustomForm;
